import { render } from "./index.vue?vue&type=template&id=3c5bf7d7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c5bf7d7&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3c5bf7d7&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5bf7d7"]])

export default __exports__